/** @format */

import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconSignCircledCancelFill,
  homefieldIconSignCircledCheckOutline,
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldAvailabilityComponent } from './shared-product-availability.component';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldAvailabilityComponent],
  exports: [HomefieldAvailabilityComponent],
})
export class HomefieldAvailabilityModule {
  constructor(HomefieldIconsLibraryService: HomefieldIconsLibraryService) {
    HomefieldIconsLibraryService.registerIcons([
      homefieldIconSignCircledCheckOutline,
      homefieldIconSignCircledCancelFill,
    ]);
  }
}
